var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleDownload = function SvgGoogleDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 95 29"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_download_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "38.913%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBDA09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_download_svg__c",
    x1: "0%",
    x2: "69.306%",
    y1: "58.476%",
    y2: "39.083%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#01E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#01C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_download_svg__e",
    x1: "20.281%",
    x2: "83.82%",
    y1: "20.102%",
    y2: "83.621%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#28D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#02F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_download_svg__f",
    x1: "74.488%",
    x2: "10.108%",
    y1: "17.43%",
    y2: "91.184%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2414E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E02554"
  })), /*#__PURE__*/React.createElement("path", {
    id: "google_download_svg__a",
    d: "M7.034 2.233c.54-.953 1.419-.95 1.958 0l7.699 13.563c.54.952.099 1.724-1.015 1.724H.35c-1.101 0-1.554-.775-1.015-1.724z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.145 .6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.24,
    height: 27.039,
    x: 0.315,
    y: 0.315,
    fill: "#FFF",
    stroke: "#E9EAF5",
    strokeWidth: 0.63,
    rx: 3.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3C50",
    d: "M32.946 6.752h.159v.022c.209 1.53-.836 2.41-2.088 2.399a2.23 2.23 0 0 1-2.231-2.224c0-1.228.999-2.224 2.23-2.224.645 0 1.186.224 1.556.614l-.435.433c-.271-.276-.657-.428-1.102-.428-.888 0-1.609.719-1.609 1.605s.72 1.604 1.61 1.604c.77 0 1.348-.385 1.486-1.2h-1.477v-.601zm16.798 2.446a2.27 2.27 0 0 1-2.272-2.268 2.27 2.27 0 0 1 2.272-2.268 2.27 2.27 0 0 1 2.273 2.268 2.27 2.27 0 0 1-2.273 2.268m0-.693c.872 0 1.578-.705 1.578-1.575s-.706-1.575-1.578-1.575c-.871 0-1.578.705-1.578 1.575s.707 1.575 1.578 1.575M34.341 7.182v1.386h1.83v.504h-2.524V4.851h2.525v.504h-1.83v1.323h1.64v.504zm4.293-1.827v3.717h-.695V5.355h-1.073v-.504h2.84v.504zm6.186 0v3.717h-.694V5.355h-1.073v-.504h2.84v.504zm-3.093-.504h.694v4.221h-.694zm11.552 0h.127l1.893 3.089V4.85h.695v4.221h-.695l-2.02-3.294v3.294h-.694V4.851z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3B3C50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.177 12.411h3.58s2.06.35 2.06 2.71c0 2.362-2.06 2.712-2.06 2.712h-3.58zm.695 1.311v2.91h2.43s1.105 0 1.105-1.455-1.106-1.455-1.106-1.455z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.152 16.32h.332v.047c.436 3.188-1.744 5.023-4.358 5-2.571-.004-4.656-2.075-4.656-4.636s2.085-4.635 4.656-4.635c1.344 0 2.473.468 3.246 1.28l-.908.903c-.567-.576-1.371-.892-2.3-.892a3.35 3.35 0 0 0-3.358 3.344 3.35 3.35 0 0 0 3.359 3.345c1.61 0 2.814-.804 3.103-2.504h-3.083v-1.251zm30.71-3.909h1.262v8.82h-1.262zm6.691 0h1.263v8.82h-1.263zm5.942 8.19c-.348.286-.904.555-1.782.61-2.011.125-2.012-1.707-2.012-1.83 0-.124-.1-1.618 1.5-1.855 1.134-.168 1.927.112 2.294.29v-.26c-.09-.343-.369-.973-1.206-.973-1.15 0-1.403.62-1.403.62l-1.052-.62s.589-1.211 2.354-1.211c2.196 0 2.57 1.511 2.57 2.02v3.836h-1.263zm-.09-1.89s-2.432-.654-2.517.71 2.334.708 2.55-.258c0-.308-.033-.452-.033-.452m3.722 2.185-2.251-5.335h1.262l1.62 3.84 1.607-3.81h1.262l-3.415 8.097h-1.263zm-19.092-3.273-3.993 1.647s.258.91 1.459.917c.94.004 1.47-.832 1.47-.832l1.013.685s-.817 1.32-2.491 1.32c-2.058 0-2.964-1.796-2.964-2.962 0-1.124.72-3.026 2.836-3.026s2.67 2.25 2.67 2.25m-1.52-.467s-.502-.763-1.272-.622c-1.63.298-1.425 1.721-1.425 1.721zm-5.88-4.745h1.336v8.801h-1.336zm-2.137 3.152 1.234.01v5.554c0 1.42-.846 2.917-2.839 2.917s-2.636-1.762-2.636-1.762l1.134-.476s.345 1.086 1.56 1.086c1.385 0 1.547-1.257 1.547-1.687v-.603s-.48.748-1.669.748c-1.29 0-2.822-1.102-2.822-2.982s1.443-2.956 2.837-2.995c1.117-.031 1.654.74 1.654.74zm-1.563 4.659c.9 0 1.63-.823 1.63-1.839s-.73-1.838-1.63-1.838-1.63.823-1.63 1.838.73 1.839 1.63 1.839m-6.488 1.135a3 3 0 0 1-3.006-2.993c0-1.652 1.346-2.992 3.006-2.992s3.005 1.34 3.005 2.992a3 3 0 0 1-3.005 2.993m-.02-1.174c.933 0 1.69-.814 1.69-1.819s-.757-1.818-1.69-1.818-1.69.814-1.69 1.818.757 1.82 1.69 1.82m-6.482 1.174a3 3 0 0 1-3.006-2.993 3 3 0 0 1 3.006-2.992c1.66 0 3.005 1.34 3.005 2.992a3 3 0 0 1-3.005 2.993m-.02-1.174c.933 0 1.69-.814 1.69-1.819s-.757-1.818-1.69-1.818-1.69.814-1.69 1.818.757 1.82 1.69 1.82"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.88 4.284)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_download_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_download_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_download_svg__a",
    fill: "url(#google_download_svg__b)",
    transform: "rotate(90 8.013 9.52)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_download_svg__c)",
    d: "m0 .624 8.824 8.753-8.938 9.099z",
    mask: "url(#google_download_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_download_svg__e)",
    d: "M-1.815-1.178 8.823 9.379l3.163-3.01z",
    mask: "url(#google_download_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_download_svg__f)",
    d: "m8.825 9.377 4.842 4.87-14.465 4.871z",
    mask: "url(#google_download_svg__d)"
  })))));
};
export default SvgGoogleDownload;